import React from 'react';
import ReactDOM from 'react-dom';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.state = {
            showMenu: false,
            menuClass: '',
        };
    }

    toggleMenu(event) {
        event.preventDefault();
        let targetElement = ReactDOM.findDOMNode(event.target);
        let clickedItem;

        if (targetElement.tagName == 'A' || targetElement.tagName == 'a') {
            clickedItem = event.target.parentElement;
        } else {
            clickedItem = event.target;
        }

        let clickedID = clickedItem.id;
        switch (clickedID) {
            case 'aboutMenu':
                this.gotoElement('aboutHeader');
                break;
            case 'messageMenu' :
                this.gotoElement('messageHeader');
                break;
            case 'serviceMenu' :
                this.gotoElement('serviceHeader');
                break;
            case 'galleryMenu' :
                this.gotoElement('galleryHeader');
                break;
            case 'teamMenu' :
                this.gotoElement('teamHeader');
                break;
            case 'formMenu' :
                this.gotoElement('formHeader');
                break;
            case 'communityMenu' :
                this.gotoElement('communityHeader');
                break;
            case 'contactMenu' :
                this.gotoElement('contactHeader');
                break;
            case 'testimonialMenu':
                this.gotoElement('testimonialHeader');
                break;
            case 'adoptionMenu':
                this.gotoElement('adoptionHeader');
                break;
            case 'locationMenu':
                this.gotoElement('contactHeader');
                this.props.showLocationModal();
                break;
        }

        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (this.state.showMenu && width < 1400) {
            this.setState({showMenu: !this.state.showMenu});
            this.setState({menuClass: ''});
        } else if (width < 1400) {
            this.setState({showMenu: !this.state.showMenu});
            this.setState({menuClass: 'open'});
        }
    }

    gotoElement(elemID) {
        let elem = document.getElementById(elemID);
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = elem.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        let offsetPosition;
        if (this.props.PCBID === "PCB00108708" && elemID === 'adoptionHeader') {
            offsetPosition = elementPosition - 330;
        } else {
            offsetPosition = elementPosition - 130;
        }

        let left = elem.getBoundingClientRect().left - 20;
        window.scrollTo({
            top: offsetPosition,
            left: left,
            behavior: 'smooth'
        });
    }

    handleScroll = () => {
        const offset = window.scrollY;
        if (offset > 10) {
            this.setState({isSticky: true});
        } else {
            this.setState({isSticky: false});
        }
    }

    componentDidUpdate() {
        window.addEventListener('scroll', this.handleScroll);
        return () => {
            window.removeEventListener('scroll', () => this.handleScroll);
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        return () => {
            window.removeEventListener('scroll', () => this.handleScroll);
        };
    }

    showMessagesMenu = () => {
        if (this.props.messageEnabled) {
            return (
                <li className="nav-list__item" id="messageMenu" onClick={this.toggleMenu}>
                    <a href='#'>From Us</a>
                </li>
            )
        }
    }

    showTeamMenu = () => {
        if (this.props.teamStatus)
            return (
                <li className="nav-list__item" id="teamMenu" onClick={this.toggleMenu}>
                    <a href='#'>Team</a>
                </li>
            )
    }

    showFormMenu = () => {
        if (this.props.formStatus)
            return (
                <li className="nav-list__item" id="formMenu" onClick={this.toggleMenu}>
                    <a href='#'>Forms</a>
                </li>
            )
    }

    showServiceMenu = () => {
        if (this.props.serviceStatus)
            return (
                <li className="nav-list__item" id="serviceMenu" onClick={this.toggleMenu}>
                    <a href='#'>Services</a>
                </li>
            )
    }

    showTestimonialMenu = () => {
        if (this.props.testimonialStatus)
            return (
                <li className="nav-list__item" id="testimonialMenu" onClick={this.toggleMenu}>
                    <a href='#'>Testimonials</a>
                </li>
            )
    }

    showAdoptionMenu = () => {
        if (this.props.isPetDistributor) {
            if (this.props.PCBID === "PCB00108391" || this.props.PCBID === "PCB00108393" || this.props.PCBID === "PCB00108708") {
                if (this.props.adoptType === "Breeder") {
                    return (
                        <li className="nav-list__item" id="adoptionMenu" onClick={this.toggleMenu}>
                            <a href='#'>For Sale</a>
                        </li>
                    )
                } else if (this.props.adoptType === "Rescue/Shelter") {
                    return (
                        <li className="nav-list__item" id="adoptionMenu" onClick={this.toggleMenu}>
                            <a href='#'>Adoptions</a>
                        </li>
                    )
                }
            }
        }
    }

    backToHome = (e) => {
        e.preventDefault();
        window.scrollTo({top: 0, behavior: 'smooth'});
        return true;
    }

    showLogo = () => {
        if (this.props.headerInfo && this.props.headerInfo.web_logo_type === 'horizontal_logo') {
            return (
                <a className="logo" href='#' onClick={this.backToHome}>
                    <img className="logo__image" alt={document.title}
                         src={this.props.headerInfo && this.props.headerInfo.web_logo}/>
                </a>
            )
        }
        if (this.props.headerInfo && this.props.headerInfo.web_logo_type === 'square_logo_and_name') {
            return (
                <a className="logo square_name" href='#' onClick={this.backToHome}>
                    <img className="logo__image logo__image--sqaure_name" alt={document.title}
                         src={this.props.headerInfo && this.props.headerInfo.web_logo}/>
                    <span className="logo__name">{this.props.headerInfo && this.props.headerInfo.web_title}</span>
                </a>
            )
        } else {
            return (
                <a className="logo" href='#' onClick={this.backToHome}>
                    <img className="logo__image" alt={document.title}
                         src={this.props.headerInfo && this.props.headerInfo.web_logo}/>
                </a>
            )
        }
    }

    showLocationsMenu = () => {
        if (this.props.locationListStatus) {
            return (
                <li className="nav-list__item" id="locationMenu" onClick={this.toggleMenu}>
                    <a href="#">{this.props.locationDisplayName}</a>
                </li>
            )
        }
    }


    render() {
        return (
            <header className={this.state.menuClass + " " + (this.state.isSticky ? "sticky" : "")}>
                <div className="content">
                    {this.showLogo()}
                    <nav>
                        <ul className="nav-list">
                            <li className="nav-list__item" id="aboutMenu" onClick={this.toggleMenu}>
                                <a href='#'>About</a>
                            </li>
                            {this.showTeamMenu()}
                            {this.showAdoptionMenu()}
                            {this.showMessagesMenu()}
                            {this.showServiceMenu()}
                            <li className="nav-list__item" id="galleryMenu" onClick={this.toggleMenu}>
                                <a href='#'>Gallery
                                </a>
                            </li>
                            {this.showFormMenu()}
                            {this.showTestimonialMenu()}
                            {this.showLocationsMenu()}
                            <li className="nav-list__item" id="contactMenu" onClick={this.toggleMenu}>
                                <a href='#'>Contact Us</a>
                            </li>
                        </ul>
                    </nav>
                    <span className="hamburger-box" onClick={this.toggleMenu}>
                        <span className="hamburger-box__inner">Menu</span>
                    </span>
                </div>
            </header>
        );
    }
}

export default Header;